import React, { Fragment, ReactElement, useEffect, useState } from "react";

import {
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from "reactstrap";
import CustomAsideBar from "./layout/CustomAsideBar";
import { useAppDispatch, useAppSelector } from "src/state/store/store";
import { setOffcanvasOpen, toggleOffcanvas } from "src/state/slices/asideslice";
import { Link } from "react-router-dom";
import { getNavigation } from "src/navigation/NavigationUtils";
import { CNavBarItemT } from "src/navigation/navigationType";
const CustomNavBar = () => {
  const [navList, setNavList] = useState([]);
  const auth = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  const isOffcanvasOpen = useAppSelector(
    (state) => state.offcanvas.isOffcanvasOpen
  );
  const handleToggleOffcanvas = () => {
    dispatch(toggleOffcanvas());
  };
  useEffect(() => {
    setNavList(getNavigation(auth?.user?.type, auth?.user?.approval_status));
  }, [auth.activeAccount, auth.user]);

  return (
    <>
      <CustomAsideBar
        isOpen={isOffcanvasOpen}
        toggleSidebar={handleToggleOffcanvas}
        openNavList={navList}
      />
      <Navbar
        dark
        expand={auth.token != null ? "xxl" : "lg"}
        container="lg"
        style={{ background: "#4353ab" }}
      >
        <Link to="/">
          <div className="d-flex align-items-center">
            <img
              src={require("src/assets/img/site-logo.png")}
              style={{ height: 50, background: "white", marginRight: 20 }}
            />
            <div className="text-white d-md-block">
              International Faculty Research and Journal Index
            </div>
          </div>
        </Link>
        <NavbarToggler onClick={handleToggleOffcanvas} />
        <Collapse navbar>
          <Nav className="ml-auto" navbar>
            {navList.map((navItem, index) => {
              if (navItem.children != null) {
                return <MultiOptionNavItem item={navItem} key={index} />;
              } else {
                return (
                  <NavItem key={index}>
                    <NavLink
                      href="#"
                      onClick={() =>
                        navItem?.onClick != null
                          ? navItem.onClick(dispatch)
                          : null
                      }
                    >
                      <Link to={navItem.href}>{navItem.label}</Link>
                    </NavLink>
                  </NavItem>
                );
              }
            })}
          </Nav>
        </Collapse>
      </Navbar>
    </>
  );
};

type MultiOptionNavItemPropsT = {
  item: CNavBarItemT;
  showIcons?: boolean;
  className?: string;
};

export const MultiOptionNavItem: React.FC<MultiOptionNavItemPropsT> = ({
  item,
  showIcons,
  className,
}) => {
  const dispatch = useAppDispatch();
  return (
    <UncontrolledDropdown nav inNavbar>
      <DropdownToggle
        nav
        className={"d-flex align-items-center px-3 nav-link " + className}
      >
        {showIcons == true && (
          <span style={{ marginRight: "15px", fontSize: "20px" }}>
            {item.icon}
          </span>
        )}

        {item.label}
      </DropdownToggle>
      <DropdownMenu aria-labelledby="nav-inner-primary_dropdown_1" end>
        {item.children.map((i, index) => {
          return (
            <Fragment key={index}>
              {i.showDivider == true && <DropdownItem divider />}
              <Link
                to={i.href}
                onClick={() => {
                  if (item?.onClick != null) item?.onClick(dispatch);
                  if (showIcons) dispatch(setOffcanvasOpen(false));
                }}
              >
                <DropdownItem>{i.label}</DropdownItem>
              </Link>
            </Fragment>
          );
        })}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};
export default CustomNavBar;
